import { Link } from "react-router-dom";

const adminLinks = [
  { label: "Story Desk", to: "/office-use" },
  { label: "Sponsors", to: "/admin/sponsors" },
  { label: "Livestreams", to: "/admin/livestreams" },
  { label: "Submissions", to: "/admin/submissions" },
];

export const NewsroomAdminNav = () => (
  <nav className="mb-8 flex flex-wrap gap-3 sm:gap-4" data-testid="newsroom-admin-nav">
    {adminLinks.map((item) => (
      <Link key={item.to} className="border border-[#D9DCE1] bg-white px-4 py-3 text-xs font-bold uppercase tracking-[0.18em] text-[#0A0A0A] transition-[background-color,color,transform] duration-200 hover:-translate-y-0.5 hover:bg-[#1338BE] hover:text-white" data-testid={`newsroom-admin-nav-link-${item.label.toLowerCase()}`} to={item.to}>
        {item.label}
      </Link>
    ))}
  </nav>
);